import { render, staticRenderFns } from "./TaskHeader.vue?vue&type=template&id=c70e933a&scoped=true"
import script from "./TaskHeader.vue?vue&type=script&lang=js"
export * from "./TaskHeader.vue?vue&type=script&lang=js"
import style0 from "./TaskHeader.scss?vue&type=style&index=0&id=c70e933a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70e933a",
  null
  
)

export default component.exports